<template>
  <section class="price-container">
    <p class="btn-title">
      {{ title }}
      <a v-if="lightBoxCopy.title" class="info-button_popin" @click="togglePopin">
        <svg class="icon-info_small">
          <use xlink:href="#icon-Info_small" />
        </svg>
      </a>
    </p>
    <template v-if="country === 'uk'">
      <h1 v-if="currency2" class="price">{{currency2}} {{ Intl.NumberFormat('en-US').format(Math.round(price))}} </h1>
    </template>
         <template v-else-if="country === 'latvia'">
      <h1 v-if="currency" class="price">{{ Intl.NumberFormat('lv-LV').format(price)}} {{currency}}</h1>
    </template>
    <template v-else>
     <h1 v-if="currency2" class="price">{{currency2}} {{ Intl.NumberFormat('de-DE').format(price)}} </h1>
      <h1 v-if="currency" class="price">{{ Intl.NumberFormat('de-DE').format(price)}} {{currency}}</h1>
    </template>

 
    <lightbox :visible="lightboxVisible" v-on:close="lightboxVisible = false">
      <div class="lightbox-simple-content">
        <ul>
          <li>
            <span v-html="lightBoxCopy.title" />
            <p v-html="lightBoxCopy.subtitle" />
          </li>
        </ul>
      </div>
    </lightbox>
  </section>
</template>

<script>
import { mapState } from "vuex";
import Lightbox from "@/components/shared/LightBox";
export default {
  props: {
    title: String,
    lightBoxCopy: Object,
    price: [String, Number],
    currency: String,
    currency2: String
  },
  data() {
    return {
      currentIndex: 0,
      lightboxVisible: false
    };
  },
  components: {
    Lightbox
  },
  computed: {
    ...mapState({
      country: state => state.country
    })
  },
  methods: {
    togglePopin() {
      this.lightboxVisible = !this.lightboxVisible;
    },
  }
}
</script>
